import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.promise.finally";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import { randomPassword, isNullOrEmpty } from '@/utils/vuex';
import scopeBreadcrumbMixin from '@/components/core/tenant/scopeBreadCrumbMixin';
import userAccessPermissionMixin from '@/components/core/tenant/userAccessPermissionMixin';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import uniq from 'lodash/uniq';
export default {
  name: 'ViewAccountMgmtAccountMgmtUserDetails',
  mixins: [scopeBreadcrumbMixin, userAccessPermissionMixin],
  data: function data() {
    return {
      tenantDetails: null,
      userKeyValue: [],
      showAddressData: false,
      addressPanel: null,
      loading: false,
      idPanel: null,
      contactPanel: null,
      valid: false,
      isLoading: false,
      originalUser: null,
      editedUser: {
        firstName: null,
        lastName: null,
        email: null,
        password: '',
        active: true,
        properties: {
          address: {
            street: null,
            houseNumber: null,
            postalCode: null,
            city: null,
            region: null,
            country: null
          },
          contactInfo: {
            phone: null,
            mobile: null
          },
          values: [{
            key: '',
            value: ''
          }]
        },
        scope: null,
        access: [// {
          //   tenantId: null,
          //   scopeId: null,
          //   Scope: {
          //       id: null,
          //   },
          //   roles: [{
          //           id: null,
          //           name: null
          //       }
          //   ]
          // }
        ]
      },
      uiThemes: [],
      defaultPasswordPolicy: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'inpOutlined', 'inpFilled', 'color', 'UiTheme', 'permissions'])), mapState('authentication', ['user', 'isImpersonating'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    tenantId: function tenantId() {
      return this.$route.params.tenantId;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    passwordRules: function passwordRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED');
      }, function (v) {
        return v.length >= _this2.defaultPasswordPolicy.length || _this2.$i18n_tc('accMgmt.user.passwordErrors.USER_PASSWORD_MINLENGTH', _this2.defaultPasswordPolicy.length, {
          n: _this2.defaultPasswordPolicy.length
        });
      }];
    },
    emailRules: function emailRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return /.+@.+\..+/.test(v) || _this3.$i18n_t('Common.emailValid');
      }];
    },
    headerButtons: function headerButtons() {
      var buttons = [];

      if (this.editedUser.active && this.canImpersonateUser(this.editedUser.access)) {
        buttons.push({
          icon: 'fal fa-user-ninja',
          dataCy: 'btn_imporsonate_user',
          title: this.$i18n_t('accMgmt.tenant.impersonateUser'),
          valid: !this.isImpersonating,
          action: 'impersonate'
        });
      }

      buttons.push({
        icon: 'fas fa-save',
        dataCy: 'btn_save_user',
        title: this.$i18n_t('Common.save'),
        type: 'submit',
        action: 'saveData'
      });
      buttons.push({
        icon: 'fal fa-times',
        dataCy: 'btn_cancel_edit_user',
        color: 'danger',
        action: 'cancel',
        tooltip: this.$i18n_t('Common.cancel')
      });
      return buttons;
    }
  }),
  watch: {},
  mounted: function mounted() {
    var _this4 = this;

    this.$store.state.app.loading = false; // first wait until all session-users access-scopes and hierarchies have been loaded/cached

    this.doFetchSessionAccessDetails().then(function () {
      return _this4.fetchTenantData();
    }).then(function () {
      // then fetch details about the to-be-edited user
      if (_this4.$route.params.id) {
        return ApiService.getUser(_this4, _this4.$route.params.id).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
            var allUsersScopes;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    allUsersScopes = uniq(data.access.map(function (access) {
                      return access.scopeId;
                    }));
                    _this4.uiThemes = data.access.map(function (a) {
                      return a.Tenant;
                    }); // fetch all scope-details for all accesses of the edited user
                    // this includes all ancestor-info for all scopes as well

                    _context.next = 4;
                    return Promise.all(allUsersScopes.map(function (scopeId) {
                      return _this4.fetchScopeDetails({
                        id: scopeId
                      });
                    })).catch(function () {
                      /* */
                    });

                  case 4:
                    _this4.setUserDetails(data);

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).finally(function () {
          _this4.$store.state.app.loading = false;
        });
      } else {
        _this4.setUserDetails({
          active: true
        });
      }
    }).catch(function (e) {
      console.error('Error during details-fetch', e);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$router.push({
      path: "/account-mgmt/".concat(this.$route.query.active || this.$route.params.tenantId, "?userlist")
    });
  },
  methods: {
    dataCyFromPropertyKey: function dataCyFromPropertyKey(key, name) {
      var propName = key.toLowerCase().replace(/[^a-z0-9_]/g, '_');
      return propName ? "".concat(name, "_").concat(propName) : undefined;
    },
    cancelUserEdit: function cancelUserEdit() {
      this.$router.push({
        path: "/account-mgmt/".concat(this.$route.params.tenantId, "?userlist")
      });
    },
    requiredRuleKeyValue: function requiredRuleKeyValue(kv) {
      var _this5 = this;

      return [function (v) {
        return isNullOrEmpty(kv.key) && isNullOrEmpty(kv.value) || !!v || _this5.$i18n_t('Common.fieldRequired');
      }];
    },
    fetchDefaultRoles: function fetchDefaultRoles(scopeId) {
      var _this6 = this;

      ApiService.fetchDefaultRoles(scopeId).then(function (roles) {
        _this6.editedUser.access = [{
          tenantId: get(roles, '[0].tenantId') || _this6.$route.params.tenantId,
          scopeId: scopeId,
          Scope: {
            id: scopeId
          },
          roles: roles,
          primary: true
        }];
        _this6.editedUser = cloneDeep(_this6.editedUser);
      }).catch(function () {
        _this6.$snack(_this6.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
      });
    },
    fetchTenantData: function fetchTenantData() {
      var _this7 = this;

      return Promise.all([ApiService.tenantGetPasswordPolicy(), // NOTE: using `no-descendents` to not get any child-data; this will ALSO _NOT_ load any scope-descendents
      ApiService.tenantGetById(this.$route.params.tenantId, ['no-descendents'])]).then(function (data) {
        _this7.defaultPasswordPolicy = data[0];
        var tenant = data[1];
        _this7.tenantDetails = tenant;
        return tenant;
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack('Failed to fetch tenant', 'error');
        }

        _this7.$router.push({
          path: "/account-mgmt/".concat(_this7.$route.params.tenantId, "?userlist")
        });
      });
    },
    validate: function validate() {
      this.valid = this.$refs && this.$refs.form ? this.$refs.form.validate() : false;

      if (this.valid) {
        this.snackbar = true;
      }
    },
    handleSubmit: function handleSubmit() {
      this.validate();

      if (this.valid) {
        this.saveUser(this.editedUser);
      }
    },
    saveUser: function saveUser(userInfo) {
      this.loading = true;
      userInfo.properties.values = get(this, 'userKeyValue', []).filter(function (kv) {
        return kv.key !== '' && kv.value !== '';
      });

      if (userInfo.id) {
        this.updateUser(userInfo);
      } else {
        this.createUser(userInfo);
      }
    },
    createUser: function createUser(user) {
      var _this8 = this;

      // as username, use the email. It is the same anyway
      user.username = user.email;
      ApiService.createUser(this.$route.params.tenantId, user).then(function () {
        _this8.$snack(_this8.$i18n_t('accMgmt.user.createSuccessSnack'), 'success');

        _this8.$router.push({
          path: "/account-mgmt/".concat(_this8.$route.params.tenantId, "?userlist")
        });
      }).catch(function (error) {
        if (error.response && _this8.$i18n_t("Error.".concat(error.response.data.message))) {
          _this8.$snack(_this8.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this8.$snack(_this8.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
        }
      }).finally(function () {
        _this8.loading = false;
      });
    },
    updateUser: function updateUser(user) {
      var _this9 = this;

      ApiService.updateUser(user).then(function () {
        return ApiService.updateUserAccess(user, _this9.originalUser);
      }).then(function () {
        _this9.$snack(_this9.$i18n_t('accMgmt.user.editSuccessSnack'), 'success');

        _this9.$router.push({
          path: "/account-mgmt/".concat(_this9.$route.params.tenantId, "?userlist")
        });
      }).catch(function (error) {
        if (error.response && _this9.$i18n_t("Error.".concat(error.response.data.message))) {
          _this9.$snack(_this9.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this9.$snack(_this9.$i18n_t('accMgmt.user.editFailedSnack'), 'error');
        }

        console.error('Error updating user access', error);
      }).finally(function () {
        _this9.loading = false;
      });
    },
    addKeyValuePair: function addKeyValuePair() {
      this.userKeyValue = cloneDeep(this.userKeyValue.concat([{
        key: '',
        value: ''
      }]));
    },
    removeKeyValuePair: function removeKeyValuePair(index) {
      pullAt(this.userKeyValue, [index]);

      if (this.userKeyValue.length === 0) {
        this.addKeyValuePair();
      } // trigger a UI refresh


      this.userKeyValue = cloneDeep(this.userKeyValue);
    },
    setUserDetails: function setUserDetails(details) {
      this.originalUser = cloneDeep(details);
      this.editedUser = cloneDeep(details);
      this.editedUser.password = randomPassword();

      if (!get(this.editedUser, 'properties.address')) {
        set(this.editedUser, 'properties.address', {});
      }

      if (!get(this.editedUser, 'properties.contactInfo')) {
        set(this.editedUser, 'properties.contactInfo', {});
      }

      if (!get(this.editedUser, 'properties.tenantIdThemeSetting')) {
        set(this.editedUser, 'properties.tenantIdThemeSetting', get(details, 'access[0].Tenant'));
      }

      if (!get(this.editedUser, 'access')) {
        set(this.editedUser, 'access', []);
      }

      if (!isArray(get(this.editedUser, 'properties.values')) || get(this.editedUser, 'properties.values', []).length === 0) {
        if (get(this.tenantDetails, 'data.userDefaultProperties') && get(this.tenantDetails, 'data.userDefaultProperties').length) {
          this.editedUser.properties.values = get(this.tenantDetails, 'data.userDefaultProperties', []).map(function (key) {
            return {
              key: key,
              value: ''
            };
          });
        } else {
          this.editedUser.properties.values = [{
            key: '',
            value: ''
          }];
        }
      }

      this.userKeyValue = this.editedUser.properties.values;
      this.validate();
    },
    updatedUserAccess: function updatedUserAccess(access) {
      this.editedUser.access = access;

      if ((access || []).length === 0) {
        delete this.editedUser.scope;
      }
    }
  }
};